import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy } from '@angular/core';

import { Icon } from '@design-system/components/atoms/icon/entities/icon.types';
import { AlertAlign, AlertSize, AlertType } from '@design-system/components/molecules/alert/entities/alert.types';
import { SegmentConnectionTypes } from '@shared/flight-segment-connection/entities/segment-types';

@Component({
  selector: 'app-segment-connection',
  templateUrl: './segment-connection.component.html',
  styleUrls: ['./segment-connection.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SegmentConnectionComponent {

  @Input() type: string;
  @Input() message: string;
  @Input() notBorderRadius: boolean;

  public readonly alertSize = AlertSize.SM;
  public readonly alertAlign = AlertAlign.Center;

  constructor() { }

  get alertType(): AlertType {
    return this.scaleType ? AlertType.Warning : AlertType.Default;
  }

  get icon(): Icon {
    return this.isNotTechnicalStop ? this.scaleType ? Icon.Stop : Icon.Clock : null;
  }

  get totalType(): boolean {
    return this.type === SegmentConnectionTypes.TOTAL;
  }

  get scaleType(): boolean {
    return this.type === SegmentConnectionTypes.SCALE;
  }

  get isNotTechnicalStop(): boolean {
    return this.type !== SegmentConnectionTypes.TECHNICAL_STOP;
  }

}
